// ContactForm.jsx
import React, { useState } from "react";
import { toast } from "react-toastify";

function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleForm = async (e) => {
    e.preventDefault();

    const { name, email, subject, message } = formData;
    if (!name || !email || !subject || !message) {
      toast.error("All fields are required.");
      return;
    }

    setLoading(true);

    try {
      const uri = `${process.env.REACT_APP_NODE_SERVER}v1/connectsupport`;

      const response = await fetch(uri, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, subject, message }),
      });

      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();

      if (data.message) {
        toast.success(data.message);
      } else {
        toast.success("Support Request Added Successfully");
      }

      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      toast.error("Unable to add support request.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden flex flex-col md:flex-row">
      <form
        onSubmit={handleForm}
        className="p-8 bg-slate-200  w-full  flex flex-col space-y-5"
        noValidate>
        <div>
          <label
            htmlFor="name"
            className="block mb-1 font-medium text-slate-900">
            Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your Name"
            className="w-full rounded border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-slate-500"
            required
          />
        </div>

        <div>
          <label
            htmlFor="email"
            className="block mb-1 font-medium text-slate-900">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Your Email"
            className="w-full rounded border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-slate-500"
            required
          />
        </div>

        <div>
          <label
            htmlFor="subject"
            className="block mb-1 font-medium text-slate-900">
            Subject
          </label>
          <input
            type="text"
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            placeholder="Subject"
            className="w-full rounded border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-slate-500"
            required
          />
        </div>

        <div>
          <label
            htmlFor="message"
            className="block mb-1 font-medium text-slate-900">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows={5}
            placeholder="Your message here..."
            className="w-full rounded border border-gray-300 px-4 py-3 resize-y focus:outline-none focus:ring-2 focus:ring-slate-500"
            required
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className={`w-full py-3 rounded font-semibold text-white ${
            loading
              ? "bg-slate-700 cursor-not-allowed"
              : "bg-slate-900 hover:bg-slate-800"
          } transition-colors`}>
          {loading ? "Sending..." : "Send"}
        </button>
      </form>
    </div>
  );
}

export default ContactForm;
